module.exports = __webpack_public_path__ + "img/蒙版(1).473395e5.png";